<template>
  <div class="operation-box">
    <template v-for="(item,index) in actions">
      <el-button class="item" :disabled="typeof(item.disabled) == 'function' ? item.disabled() : item.disabled" v-if="item.type === 'button'" :icon="item.icon" :key="'action-'+index" :type="item.theme" @click="item.action">
        {{item.title}}
      </el-button>
      <el-select class="item" :filterable="item.filterable || false" clearable :key="'action-'+index" v-if="item.type === 'select'" v-model="item.selectValue" :placeholder="'请选择' + item.title" @change="item.action(item)">
        <el-option v-for="i in (typeof item.options === 'function' ? item.options() : item.options)" :key="i.value" :label="i.title" :value="i.value" />
      </el-select>
      <el-select class="item" clearable :filterable="item.filterable || false" :key="'action-'+index" v-if="item.type === 'selectGroup'" v-model="item.selectValue" :placeholder="'请选择' + item.title" @change="item.action(item)">
        <el-option-group
          v-for="group in (typeof item.options === 'function' ? item.options() : item.options)"
          :key="group.value"
          :label="group.title"
        >
          <el-option
            v-for="i in group.children"
            :key="i.id"
            :label="i.title"
            :value="i.value"
          >
          </el-option>
        </el-option-group>
      </el-select>
      <el-date-picker
        v-if="item.type === 'datePicker'"
        :key="'action-'+index"
        v-model="item.value"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="item.action(item)"
        value-format="yyyy-MM-dd"
        :picker-options="item.pickOptions"
      >
      </el-date-picker>
    </template>

    <div class="filter-box" v-if="filters">
      <template v-for="(item,index) in filters">
        <el-input :key="'filter-'+index" clearable placeholder="请输入要搜索的内容" v-model="item.searchValue" class="input-with-select">
          <el-select v-if="item.options" v-model="item.type" slot="prepend" placeholder="请选择" style="width: 150px;" @change="onOptionChanged">
            <el-option :label="v.title" :value="v.value" v-for="(v,i) in item.options" :key="'option-' + i"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="item.action(item)"></el-button>
        </el-input>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OperationBoxComponent',
  props: {
    actions: {},
    filters: {},
    disabled: {}
  },
  methods: {
    onOptionChanged: function (e) {
      console.log(e)
    }
  }
}
</script>

<style scoped lang="less">
.operation-box {
  padding: 20px;
  border-bottom: solid 1px #ddd;

  .item {
    margin: 0 2px;
  }

  .filter-box {
    width: 450px;
    display: inline-block;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/OperationBoxComponent.vue